// Helpers
import { to } from '../../../lib/helpers';
import {
  checkRequestFailure,
  handleRequestFailure,
  ERRORS_MAP,
} from '../../../lib/validation';
import { gaActions } from '../../gaActionTypes';

// Requests
import { userUpdateAddressRequest } from '../../../backend/userRequests';

// Actions
import { openModal } from '../../../reducers/modal/modalActions';

// Consts
export const USER_UPDATE_ADDRESS_SUCCESS_RECEIVED = `[USER] ${gaActions.submit} Update Address Success`;
export const UPDATE_VERSION_ID = `[USER] Update Address Version ID`;

export const updateAddress = ({
  values: { state, ...values },
  props: { setToggle },
  formikActions,
}) => async (dispatch, getState) => {
  const currentVersionId = getState()?.user?.addresses?.mailing?.versionId;
  const data = { ...values, state: state.value, versionId: currentVersionId };

  const [{ response, body }] = await to(
    dispatch(userUpdateAddressRequest(data))
  );

  if (body.data?.versionId) {
    data.versionId = body.data.versionId;
    dispatch({ type: UPDATE_VERSION_ID, payload: { versionId: body.data.versionId } });
  }

  if (checkRequestFailure({ response, body }))
    return handleRequestFailure(body, formikActions, ERRORS_MAP.ADDRESS);

  if (
    ['ADDRESS_TWO_INVALID', 'ADDRESS_NOT_VERIFIED', 'INVALID_ADDRESS'].includes(
      body.message
    )
  ) {
    body.status = 'SUCCESS';
    body.data = data;
  }

  if (body.status === 'WARNING') {
    formikActions.setSubmitting(false);

    switch (body.message) {
      case 'ADDRESS_TWO_MISSING':
        return dispatch(
          openModal('AddressTwoMissingModal/AccountPage', {
            enteredAddress: data,
            addressOptions: [body.data],
          })
        );
    }
  }

  if (body.status === 'CONTINUE') {
    formikActions.setSubmitting(false);
    return dispatch(
      openModal('VerifyAddressModal/AccountPage', {
        enteredAddress: data,
        addressOptions: [body.data],
      })
    );
  }

  setToggle();

  if (body.status === 'SUCCESS') {
    return dispatch({
      type: USER_UPDATE_ADDRESS_SUCCESS_RECEIVED,
      payload: body.data,
    });
  }
};